"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.usePart = exports.ItinerarySegmentProvider = exports.ItinerarySegmentContext = void 0;
var React = _interopRequireWildcard(require("react"));
const ItinerarySegmentContext = exports.ItinerarySegmentContext = /*#__PURE__*/React.createContext({
  isNextHidden: false,
  isPrevHidden: false,
  isBanner: false,
  isHidden: false,
  noElevation: false,
  opened: false,
  index: 0,
  count: 0,
  last: false
});
const usePart = () => React.useContext(ItinerarySegmentContext);
exports.usePart = usePart;
const ItinerarySegmentProvider = ({
  isNextHidden,
  isPrevHidden,
  noElevation,
  isHidden,
  isBanner,
  children,
  index,
  opened,
  last,
  count
}) => {
  const value = React.useMemo(() => ({
    isNextHidden,
    isPrevHidden,
    noElevation,
    isHidden,
    isBanner,
    index,
    opened,
    last,
    count
  }), [isNextHidden, isPrevHidden, noElevation, isHidden, isBanner, index, opened, last, count]);
  return /*#__PURE__*/React.createElement(ItinerarySegmentContext.Provider, {
    value: value
  }, children);
};
exports.ItinerarySegmentProvider = ItinerarySegmentProvider;